import React from 'react';
import { connect } from 'react-redux';
import { getSortedIds } from '../../common/helper';
import { fetchChartImage, REDUCER_NAME } from '../reducer';
import '../../top-mover.scss';
import { GridImage } from './../../../../common/grid-image';

const mapStateToProps = state => {
  return {
    listId: state[REDUCER_NAME].listDataTopNewHighTicker,
    component: state[REDUCER_NAME].component,
    sortState: state[REDUCER_NAME].sortState,
    listObjectDataTopNewHighByTicker:
      state[REDUCER_NAME].listObjectDataTopNewHighByTicker,
  };
};

const mapDispatchToProps = {
  fetchImage: fetchChartImage,
};

const getImageFromRedux = state => state[REDUCER_NAME].images;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Chart);

function Chart(props) {
  const { listId, sortState, listObjectDataTopNewHighByTicker: data } = props;
  return (
    <GridImage
      {...props}
      listId={getSortedIds(listId, sortState, data)}
      getImageFromRedux={getImageFromRedux}
    />
  );
}
